import { Component } from "@angular/core";

@Component({
  selector: 'app-epaySuccess',
  templateUrl: './epaySuccess.component.html',
  styleUrls: ['./epaySuccess.component.scss'], 
})
export class EPaySuccessComponent {

}
